import { BreadcrumbsService } from './../../../../services/cms/breadcrumbs.service';
import { Breadcrumbs } from './../../../../models/cms/breadcrumbs';
//Angular
import { Component, OnInit, ViewContainerRef,ChangeDetectionStrategy, ViewEncapsulation, Compiler, Inject, Renderer } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { SeoService } from "./../../../../services/core/seo.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";

//Models
import { ArticleCategory } from "./../../../../models/cms/news-list";
import { News } from "./../../../../models/cms/news-list";

//Services
import { LanguageService } from "./../../../../services/cms/language.service";
import { ArticleService } from "./../../../../services/cms/article.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { SeoViewModel } from "./../../../../models/core/seo";
import { ScriptService } from "./../../../../services/cms/script.service";
import { RoutesService } from "../../../../services/core/routes.service";
import { HelperService } from "./../../../../services/core/helper.service";

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    template: ""
})

export class ArticleCategoryComponent implements OnInit {

    articleCategory: ArticleCategory = new ArticleCategory();

    constructor(
        private _compiler: Compiler,
        private componentHelper: ComponentHelperService,
        private _elementRef: ViewContainerRef,
        private articleService: ArticleService,
        private languageService: LanguageService,
        private route: ActivatedRoute,
        private router: Router,
        private cmsComponentService: CmsComponentService,
        @Inject('isBrowser') private isBrowser: boolean,
        private seo: SeoService,
        private renderer: Renderer,
        @Inject(DOCUMENT) private document: any,
        private scriptService: ScriptService
        ) { this.router.routeReuseStrategy.shouldReuseRoute = () => false; }

    subManager = new Subscription();

    ngOnInit() {
        //Reading Language information
        let lang: string = this.languageService.getLongLang();

        //Reading id from url
        //If id is set, then the information is retrived by id, else by url
        let routeSub = this.route.params.subscribe(params => {

            let id = params['id'];
            let pageNumber = params['page'];
            let startRowIndex: number = 0;
            let maxRows: number = 15;

            if (pageNumber == undefined) {
                pageNumber = 0;
                startRowIndex = pageNumber * maxRows;
            }
            else if (pageNumber < 0) {
                pageNumber = 0;
                startRowIndex = pageNumber * maxRows;
            }
            else {
                startRowIndex = (pageNumber - 1) * maxRows;
            }
            let header: any;
            let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
                header = result;
                let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                    if (result1.Categories) {
                        header.Categories = result1.Categories;
    
                    }
                });
                this.subManager.add(SideMenuData);
            });
            this.subManager.add(headDataSub);

            if (id !== undefined) {
                let categoryId: string = id;

                let categorySubId = this.articleService.getCategoryArticleById(categoryId, lang, startRowIndex, maxRows)
                    .subscribe(result => {
                        if (result.SeoInformation) {
                            result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                            result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                        }
                        
                        if (this.isBrowser) {
                            this.onGetArticleSuccess(result, pageNumber, maxRows,header, categoryId);
                        }
                        else {
                            //-- Get head and body scripts
                            this.scriptService.setupExternalScripts(result, this.scriptService.typeArticleCategory, categoryId);
                            
                            //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                            this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                            this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
                        }
                    });

                this.subManager.add(categorySubId);
            }

            else {
                let url = this.router.url;
                let pageNumber = params['page'];

                if (pageNumber != undefined) {
                    url = url.slice(0, url.lastIndexOf('/'));
                }
                else {
                    pageNumber = 0;
                }

                let categorySubUrl = this.articleService.getArticleCategoryByUrl(lang, url, startRowIndex, maxRows).subscribe(result => {
                    if (this.isBrowser) {
                        this.onGetArticleSuccess(result, pageNumber, maxRows,header);
                    }
                    else {
                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeArticleCategory, result.CategoryDetails.Id);
                        
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                        this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
                    }
                });

                this.subManager.add(categorySubUrl);
            }
        });

        this.subManager.add(routeSub);
    }

    ngOnDestroy() {
        this.subManager.unsubscribe();
    }

    onGetArticleSuccess(result: any, currentPage: number, maxRows: number,header:any, categoryId?: string ) {
        ////Creating sub-component with the returned information
        let subComponent = this.createSubComponent(result, currentPage, maxRows,header,categoryId);

        ////Injecting created component (OK)
        this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
    }

    private createSubComponent(result: any, currentPage: number, maxRows: number,header:any ,categoryId?: string) {
        @Component({
            template: result.TemplateHtml
        })

        class ChildComponent implements OnInit {

            constructor(
                private seoService: SeoService,
                private scriptService: ScriptService,
                private helperService: HelperService,
                @Inject('isBrowser') private isBrowser: boolean,
                private _elementRef: ViewContainerRef,
                private languageService: LanguageService,
                private articleService: ArticleService,
                private routesService: RoutesService,
                private router: Router,
                private breadcrumbsService: BreadcrumbsService
            ) { }

            articleCategory: ArticleCategory = result.CategoryDetails;
            private seoInfo: SeoViewModel = result.SeoInformation;
            blogs: Array<News> = result.ArticleCategoryList;
            private pageIsInit: boolean = false;

            category: any;
            articleCategories: Array<ArticleCategory>;
            lang: string = this.languageService.getLongLang();
            categoryId: number = 0;
            startRowIndex: number = 0;
            maxRows: number = maxRows;
            blogCategoryPageName: string[] = [];
            blogCategoryPageNumber: string[] = [];
            blogPageName: string[] = [];
            homePageName: string[] = [];

            private currentPageNumber: number = currentPage;
            private disablePreviousPage: boolean = false;
            private disableNextPage: boolean = false;
            private numberOfPages: number = Math.ceil(result.NumberOfArticles / this.maxRows);
            private pages: any = this.createRange(this.numberOfPages);
            private zeroPage: number = 0;
            private breadcrumbs : Breadcrumbs[] = result.BreadcrumbsInfo;

           footerData: any = result.FooterData;
           headerData: any = header;

            ngOnInit() 
            {
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);

                if(this.currentPageNumber == 0)
                {
                    this.zeroPage = 1;
                }

                if (this.currentPageNumber == 0 || this.currentPageNumber == 1) {
                    this.disablePreviousPage = true;
                }
                else if (this.currentPageNumber == this.numberOfPages) {
                    this.disableNextPage = true;
                }

                this.articleCategories = result.ArticleCategories;
                this.blogPageName = this.routesService.getRoutePath('BLOG');
                this.homePageName = this.routesService.getRoutePath('HOME');

                if (categoryId != undefined) {
                    this.blogCategoryPageName = this.routesService.getRoutePath('ArticleCategoryPage');
                    this.blogCategoryPageNumber = this.routesService.getRoutePath('ArticleCategoryPageWithPaging')
                }

                else {
                    this.blogCategoryPageName.push(this.router.url)
                }


            }

            imageTitle(imgPath) {
                let imgName = this.helperService.GetFileNameFromPath(imgPath);

                return imgName;

            }            

            createRange(number) {
                var items: any[] = [];

                for (var i = 1; i <= number; i++) {
                    items.push(i);
                }

                return items;
            }

            showClickedPage(index) {
                let page = index + 1;
                let url: string;

                if (categoryId != undefined) {
                    url = this.blogCategoryPageNumber[0].replace(':id', categoryId.toString()).replace(':page', page.toString());
                }
                else {
                    if (this.currentPageNumber == 0) {
                        url = this.blogCategoryPageName + "/" + page.toString();
                    }
                    else {
                        url = this.blogCategoryPageName[0].slice(0, this.blogCategoryPageName.lastIndexOf('/')) + "/" + page.toString();
                    }
                }

                this.router.navigate([url]);
            }

            showPreviousPage() {
                let previousPage: number = this.currentPageNumber - 1;

                if (previousPage > 0) {
                    let url: string;

                    if (categoryId != undefined) {
                        url = this.blogCategoryPageNumber[0].replace(':id', categoryId.toString()).replace(':page', previousPage.toString());
                    }
                    else {
                        if (this.currentPageNumber == 0) {
                            url = this.blogCategoryPageName + "/" + previousPage.toString();
                        }
                        else {
                            url = this.blogCategoryPageName[0].slice(0, this.blogCategoryPageName.lastIndexOf('/')) + "/" + previousPage.toString();
                        }
                    }

                    this.router.navigate([url]);
                }
            }

            showNextPage() {
                let page: number = Number(this.currentPageNumber);
                if(this.currentPageNumber == 0)
                {
                    page = 1
                }
                
                let nextPage: number = page + 1;
 
                let url: string;

                if (nextPage <= this.numberOfPages) {
                    if (categoryId != undefined) {
                        url = this.blogCategoryPageNumber[0].replace(':id', categoryId.toString()).replace(':page', nextPage.toString());
                    }
                    else {
                        if (this.currentPageNumber == 0) {
                            url = this.blogCategoryPageName + "/" + nextPage.toString();
                        }
                        else {
                            url = this.blogCategoryPageName[0].slice(0, this.blogCategoryPageName.lastIndexOf('/')) + "/" + nextPage.toString();
                        }
                    }
                    this.router.navigate([url]);
                }
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                this.pageIsInit = true;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/article/sys/article-category.component.ts